export function parseApiUrl({ searchApi, autocompleteApi }) {
    if (!searchApi) {
        console.warn('SearchingAPI is not configured! Please apply this setting before using the widgets.');
        return false;
    }

    if (!autocompleteApi) {
        console.warn('AutocompleteUrl is not configured! Please apply this setting before using the widgets.');
        return false;
    }

    var search = new URL(searchApi);
    var autocomplete = new URL(autocompleteApi);

    return {
        apiUrl: search.origin,
        searchUrl: search.pathname,
        autocompleteUrl: autocomplete.href
    };
}

export function getDashboardUrl(baseApi) {
    if (!baseApi) {
        console.warn('SearchBaseAPI is not configured! Please apply this setting before using the widgets.');
        return false;
    }

    var obj = new URL(baseApi);

    return obj.origin;
}

export function mergeConfig(configA, configB) {
    var a = _.cloneDeep(configA);
    var b = _.cloneDeep(configB);

    var mergedConfig = _.merge({}, a, b);

    Object.keys(mergedConfig).forEach((key) => {
        if (_.isArray(mergedConfig[key]) && a[key] && _.isArray(a[key]) && b[key] && _.isArray(b[key])) {
            mergedConfig[key] = _.union(a[key], b[key]);
        }
    });

    return mergedConfig;
}

export function applyMappings(itemsSelector, mappingSelector) {
    var queryResults = document.querySelectorAll(itemsSelector);
    var mappingsEl = document.querySelectorAll(mappingSelector);

    if (!queryResults || !mappingsEl || (queryResults && queryResults.length == 0) || (mappingsEl && mappingsEl.length == 0)) {
        if (!mappingsEl || (mappingsEl && mappingsEl.length == 0)) {
            console.warn("Mapping parameters not suplied");
        }
        else {
            console.warn("Target for value mapping not available");
        }
    }
    else {
        try {
            var mappings = JSON.parse(mappingsEl[0].innerHTML);

            queryResults.forEach(element => {
                Object.keys(mappings).forEach(mapKey => {
                    element.textContent = element.textContent.replace(mapKey, mappings[mapKey]);
                });
            });
        }
        catch (e) {
            console.error(e);
        }
    }
}

export function addTemplateOverrides(components) {
    Object.keys(components).forEach(componentClass => {
        components[componentClass].templateOverride = "#vue-hawksearch-" + components[componentClass].name;
    });
}

export function addComponentsRefs(components) {
    let tagNames = {};

    Object.keys(components).forEach(componentClass => {
        tagNames[components[componentClass].templateOverride.replace('#vue-hawksearch-', '')] = componentClass;
    });

    Object.keys(components).forEach(componentClass => {
        let templateId = components[componentClass].templateOverride;
        let el = document.getElementById(templateId.replace('#', ''));

        if (el) {
            Object.keys(tagNames).forEach(tagName => {
                if (el.innerHTML.match('<' + tagName)) {
                    if (!components[componentClass].components) {
                        components[componentClass].components = {};
                    }

                    components[componentClass].components[tagNames[tagName]] = components[tagNames[tagName]];
                }
            });
        }
    });
}

export function documentToDict(obj) {
    if (!obj)
        return {};  

    let objToReturn = {};
    for (let property in obj) {
        if (obj[property]) {
            let arrayValue = obj[property];
            if (arrayValue.value)
                arrayValue = arrayValue.value;
            let arr = Array.from(arrayValue);
         
            if (property === 'tags') {
                objToReturn[property] = arr;
            } else {
                objToReturn[property] = arr[0];
            }
        }
    }
    return objToReturn;
}